import { AnalyticsService } from "@common-services/analytics-service";
import { useMemo } from "react";

// Module-level singleton instance to prevent multiple initializations
let analyticsServiceInstance: AnalyticsService | null = null;

function getAnalyticsServiceInstance(): AnalyticsService {
  if (!analyticsServiceInstance) {
    analyticsServiceInstance = new AnalyticsService();
  }
  return analyticsServiceInstance;
}

export function useAnalyticsService() {
  return useMemo(() => getAnalyticsServiceInstance(), []);
}
